









import { defineComponent, PropType } from '@nuxtjs/composition-api';
import { SfHeading } from '~/components/StorefrontUi';

export default defineComponent({
  name: 'SectionHeading',
  components: {
    SfHeading,
  },
  props: {
    title: {
      type: String as PropType<string>,
      required: true,
    },
    noDecor: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    level: {
      type: Number as PropType<1 | 2 | 3 | 4 | 5 | 6>,
      default: 3,
    },
  },
});
